import { getTimestampWithTimezoneOffset, getTimezoneOffsetInHours } from '../utils';

export enum CombinedDateTimeRangeType {
  Range = 'range',
  TodayShift = 'todayShift',
}

export class DatepickerRangeModel {
  start: number = null;
  end: number = null;

  constructor(params?: DatepickerRangeOutput) {
    if (params) {
      const { start, end } = params;
      Object.assign(this, {
        start: start ? +start : null,
        end: end ? +end : null,
      });
    }
  }
}

export class DatepickerWithTimezoneRangeModel {
  start: number = null;
  end: number = null;

  constructor(params?: DatepickerRangeOutput) {
    if (params) {
      const { start, end } = params;
      const localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const offset = getTimezoneOffsetInHours(localTimeZone);

      Object.assign(this, {
        start: start ? getTimestampWithTimezoneOffset(+start, offset) : null,
        end: end ? getTimestampWithTimezoneOffset(+end, offset) : null,
      });
    }
  }
}

export class CombinedDatepickerRangeModel extends DatepickerRangeModel {
  daysFromToday: { from: number; to: number; onlyWorkDays: boolean } = null;

  constructor(params?: CombinedDatepickerRangeModel) {
    super();
    if (params) {
      const { start, end, daysFromToday = null } = params;
      Object.assign(this, {
        start: start ? +start : null,
        end: end ? +end : null,
        daysFromToday,
      });
    }
  }
}

export class DatepickerRangeOutput {
  start: Date;
  end: Date;

  constructor(params?: DatepickerRangeModel) {
    if (params) {
      const { start, end } = params;
      Object.assign(this, {
        start: start ? new Date(start) : null,
        end: end ? new Date(end) : null,
      });
    }
  }
}

export class CombinedDatepickerRangeOutput extends DatepickerRangeOutput {
  daysFromToday: { from: number; to: number; onlyWorkDays: boolean };

  constructor(params?: CombinedDatepickerRangeModel) {
    super();
    if (params) {
      const { start, end, daysFromToday } = params;
      Object.assign(this, {
        start: start ? new Date(start) : null,
        end: end ? new Date(end) : null,
        daysFromToday,
      });
    }
  }
}
